import React from 'react'
import Typography from '@material-ui/core/Typography';
import { Button } from '@material-ui/core'
import { Timeline } from '@material-ui/lab'
import { useStyles } from './style';
import EventItem from './EventItem';

/**
 * AuditTrailViewer component for displaying audit trail history
 */
const AuditTrailViewer = (props) => {
  const { auditTrail, chartUniqueId } = props;
  const classes = useStyles();

  return (
    <div className={`${classes.container} myScrollContainer`}>
      <div className={classes.mainHeader}>
        <Typography className={classes.headerText}>
          Audit trails
        </Typography>
      </div>
      <div className={classes.mainContent}>
        {props.formData?.[chartUniqueId + '_audit_Trails_Obligations_loading'] ? (
          props.loader
        ) : auditTrail && auditTrail.length > 0 ? (
          <Timeline align='left' className={classes.mainTimeline}>
            {
              auditTrail.map((res, index) => (
                <EventItem
                  key={`auditlog-${res._id}`}
                  e={res}
                  last={index === auditTrail.length - 1}
                />
              ))
            }
          </Timeline>
        ) : (
          <Typography className={`${classes.messageText} ${classes.noAudit}`}>
            No audit history available yet.
          </Typography>
        )}
      </div>
      <div className={classes.footer}>
        <Button
          className={classes.closeButton}
          onClick={props.handleAuditTrailDrawerToggle}
        >
          Close
        </Button>
      </div>
    </div>
  );
}

export default AuditTrailViewer
